import * as React from 'react'
import { connect, dispatch } from 'react-redux'
import { RecordingsListComponent } from './RecordingsList'
import { IRecordingsState } from '../Recordings.reducer'
import { flow, compact } from 'lodash'
import { replace } from 'react-router-redux'
import { getNumbers } from 'features/Numbers/Numbers.actions'
import { reduxForm } from 'redux-form'
import { nonFlowServices } from 'features/Numbers/Numbers.utils'

export const formName = 'recordingsList'

export interface IRecordingsListContainerProps {
  page: number
  serviceId?: string
  ban?: string
  from?: string
}

const stateToProps = (
  { numbers, billing }: { recordings: IRecordingsState; numbers: any; billing: any },
  { serviceId, ban, from }: IRecordingsListContainerProps
) => {
  return {
    numbersById: numbers.numbersById || {},
    banOptions: [
      { name: 'Any', value: '' },
      ...billing.billingAccounts.map(account => ({
        name: `${account.ban} - ${account.customer}`,
        value: account.ban,
      })),
    ],
    numberOptions: [
      { name: 'Any', value: '' },
      ...nonFlowServices(numbers).map(num => ({
        name: compact([num.number, num.customerReference]).join(' - '),
        value: num.id,
      })),
    ],
    initialValues: {
      serviceId,
      ban,
      from,
    },
  }
}

export const dispatchToProps = {
  replace,
  getNumbers,
  dispatch,
}

export const RecordingsList = flow<any, any, React.SFC<IRecordingsListContainerProps>>(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(RecordingsListComponent)



// WEBPACK FOOTER //
// src/features/Recordings/RecordingsList/RecordingsList.container.ts